let newCurrentMenuIndex: number = 0;
let touchStartPoint: number = 0;

export function initPortfolioMenu(menuId: string) {
  const menu: HTMLElement | null = document.getElementById(menuId);
  if (menu) {
    const menuButtons: NodeListOf<HTMLElement> = menu.querySelectorAll('.button');

    const currentMenuItemIndex: number = Number(menu.dataset.currentMenuItemIndex);
    setActiveMenuItem(menu, currentMenuItemIndex);

    menuButtons.forEach((button: HTMLElement, index: number) => {
      button.addEventListener('click', (event: MouseEvent) => {
        event.preventDefault();
        setActiveMenuItem(menu, index);
      }, false);
    });

    menu.addEventListener('touchmove', touchDragMenu.bind(null, menu), false);
    menu.addEventListener('touchstart', function (event: TouchEvent) {
      touchStartPoint = event.targetTouches[0].pageX;
    }, false);
    menu.addEventListener('touchend', function (_event: TouchEvent) {
      setActiveMenuItem(menu, newCurrentMenuIndex);
    }, false);

    window.addEventListener('resize', function (_event: Event) {
      const currentMenuItemIndex: number = Number(menu.dataset.currentMenuItemIndex);
      setActiveMenuItem(menu, currentMenuItemIndex);
    });
  }
}

function setActiveMenuItem(menu: HTMLElement, position: number) {
  updateMenuRotationPosition(menu, position);

  const menuButtons: NodeListOf<HTMLElement> = menu.querySelectorAll('.button');
  menuButtons.forEach((button: HTMLElement) => {
    button.classList.remove('active');
  });

  const currentButton: HTMLAnchorElement = menuButtons.item(position) as HTMLAnchorElement;
  currentButton.classList.add('active');

  if (currentButton.dataset.name) {
    const currentEffectName: string = currentButton.dataset.name;
    updateGridEffects(currentEffectName);
  }

  menu.dataset.currentMenuItemIndex = String(position);
}

function updateMenuRotationPosition(menu: HTMLElement, position: number) {
  const circle: HTMLUListElement | null = menu.querySelector('ul');
  const menuButtons: NodeListOf<HTMLElement> = menu.querySelectorAll('.button');
  if (circle) {
    let angleIncrement: number = Number(menu.dataset.angleIncrement);
    if (window.innerWidth <= 576) {
      angleIncrement = Number(menu.dataset.angleIncrementMobile);
    }
    circle.style.transform = `rotate(-${((menuButtons.length - 1) - position) * angleIncrement}deg)`;
  }
}

function updateGridEffects(currentEffect: string) {
  const animationSpeed: number = 200;
  const aeroGrid: HTMLElement | null = document.querySelector('aero-grid');
  if (aeroGrid) {
    aeroGrid.setAttribute('global-effect', currentEffect);

    const aeroEffects: NodeListOf<HTMLElement> = aeroGrid.querySelectorAll('aero-card');
    aeroEffects.forEach((effect: HTMLElement) => {
      ['top', 'right', 'bottom', 'left'].forEach((direction: string) => {
        effect.classList.remove(direction);
      });

      effect.classList.add('show');
      setTimeout(() => {
        effect.classList.remove('show');
      }, animationSpeed);
    });
  }
}

function touchDragMenu(menu: HTMLElement, event: TouchEvent) {
  const touchLocation = event.targetTouches[0];
  const dragInertia = 2.5;
  const dragDirection: number = (touchStartPoint - touchLocation.pageX) / window.innerWidth * dragInertia;
  const currentMenuIndex: number = Number(menu.dataset.currentMenuItemIndex);
  const newPosition: number = currentMenuIndex + Math.round(dragDirection);

  newCurrentMenuIndex = Math.round(newPosition);
  updateMenuRotationPosition(menu, newPosition);
}
